import React from 'react';

/* 
  used in
  #1 /paybill ==> Pay page from menu ==> balance card section
*/
function BalanceCard({ containerClass, isPostpaid = true }) {
  return (
    <div class={`white_card dashboard_card mt-30 ${containerClass}`}>
      <div class="flex_grp_between" style={{ marginBottom: isPostpaid ? '-8px' : '' }}>
        <div class="balance_section_info">
          <label className='shimmerBG shimmer-text-xs' style={{ width: '120px' }}>
          </label>
          <h3 className='shimmerBG shimmer-text-lg' style={{ width: '180px' }}>
          </h3>
          {isPostpaid && (
            <button
              className="custom_btn custom_btn_sm custom_btn_primary_outline mt-3 shimmerBG shimmer-button-md"
              style={{ width: 'initial' }}
            >
            </button>
          )}
        </div>
        <div class={`balance_section_action ${isPostpaid ? "" : 'align-self-center'}`}>
          <button
            class="custom_btn custom_btn_sm custom_btn_primary text-initials shimmerBG shimmer-button-md"
          >
          </button>
        </div>
      </div>
    </div>
  );
}

export default BalanceCard;
